export enum WIDGET_PDF_PREVIEW {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=773775798
     */
    PDF_PREVIEW_EMPTY_STATE_TITLE = 'DESIGNER.PDF_PREVIEW_EMPTY_STATE_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=664796597
     */
    SELECT_PDF = 'WIDGET_PDF_PREVIEW.SELECT_PDF',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=643517179
     */
    WIDGET_NOT_CONFIGURED_DESCRIPTION = 'WIDGET_PDF_PREVIEW.NOT_CONFIGURED_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=803269924
     */
    NO_PDF_SELECTED = 'WIDGET_PDF_PREVIEW.NO_PDF_SELECTED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=803273193
     */
    SELECTED_PDF = 'WIDGET_PDF_PREVIEW.SELECTED_PDF',
}
